export class Sitecore {
	constructor(el) {
	}

	static isEdit() {
		return document.body.classList.contains('pageedit');
	}

	IsEdit() {
		if (document.querySelector('body').classList.contains('pageedit')) return true;
		return false;
	}

	IsPreview() {
		if (document.querySelector('body').classList.contains('page-preview')) return true;
		return false;
	}
}

export default Sitecore;
